import axios from "axios";

// Daily brief — backend writes one row per (top-15-cluster fingerprint)
// change. Endpoint: GET /api/daily-brief
//   { bullets: string[], prose: string, updatedAt: "HH:MM",
//     generatedAtFull: "YYYY-MM-DD HH:MM" }

const FALLBACK = {
  bullets: [
    "Përmbledhja ende nuk është gjeneruar. Sapo procesi i klasterizimit "
      + "të kompletohet do të shfaqet këtu.",
  ],
  prose: "",
  updatedAt: "—",
  generatedAtFull: null,
};

export const fetchDailyBrief = async () => {
  // Render free tier spins down when idle; the first request after a cold
  // start can take 30-50s. Use a generous timeout + one retry so we don't
  // fall back to the placeholder just because the API was waking up.
  const attempt = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/api/daily-brief`, {
      timeout: 45000,
    });

  for (let i = 0; i < 2; i++) {
    try {
      const res = await attempt();
      const data = res.data || {};
      const bullets = Array.isArray(data.bullets) ? data.bullets : [];
      if (bullets.length === 0) return FALLBACK;
      return {
        bullets,
        prose: typeof data.prose === "string" ? data.prose : "",
        updatedAt: data.updatedAt || "—",
        generatedAtFull: data.generatedAtFull || null,
      };
    } catch (err) {
      if (i === 1) {
        console.warn("daily-brief fetch failed, using fallback:", err.message);
        return FALLBACK;
      }
      // brief pause before the retry
      await new Promise((r) => setTimeout(r, 1500));
    }
  }
  return FALLBACK;
};
